export const MESSAGE_CONSTANTS = {
    TRY_AGAIN_LATER: 'Something went wrong, please try again later',
    DELETE_ERROR: 'Failed to delete, please try again later',
    FILL_FORM: 'Please fill the form',
    REDIRECT_TO_SIGN_IN_PAGE: 'You will be redirected to Sign-in Page. Login or Sign-up to be able to access the features',
    UNIDENTIFIED_HOMPAGE: 'Looks Like you have not set your homepage. You can choose your homepage from in the settings screen. Click the button below to go to SETTINGS',
    FIELD_REQUIRED: 'This field is required',
    CLOCKED_OUT: 'Clocked-out Successfully',
    CLOCKED_IN: 'Clocked-In Successfully'
};
